<div class="container-fluid">
  <div class="alert alert--flex alert-info c-list-alert">
    <span i18n="@@ltiRelink-status-relinkDifferentListOrSection"
      >Relink a different list or section?</span
    >
    <a
      [href]="ltiRelinkUrl"
      i18n="@@ltiRelink-link-relink"
      class="btn btn-alert"
      >Relink</a
    >
  </div>
</div>
